import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_banner_swiper_two = _resolveComponent("banner-swiper-two");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_banner_swiper_two, {
    defTabActive: _ctx.$route.query.value
  }, null, 8, ["defTabActive"])]);
}